import mixin from './mixin';
import { userStore } from './store/userStore.js';
import { useVuelidate } from '@vuelidate/core';
import { required, email, sameAs } from '@vuelidate/validators';

const loginApp = {
    setup() {
        return { v$: useVuelidate() }
    },
    mixins: [mixin],
    data() {
        return {
            step: 1,
            userExists: false,
            apiLogin: '',
            apiRegister: '',
            apiCheckUser: '',
            apiForgot: '',
            returnUrl: '',
            userlogin: true,
            forgotPassword: false,
            emailSend: false,
            accountSend: false,
            login: {
                username: '',
                password: '',
                longTerm: false
            },
            register: {
                username: '',
                acceptterms: false,
                registernewsletter: false
            },
            languageId: 'nl',
            redirectUrl: '',
            passwordChanged: false,
            data: {
                typeAlias: 'Success'
            },
            passwordType: 'password',
            loginFailed: false
        }
    },
    validations() {
        return {
            login: {
                username: { required, email },
                password: { required }
            },
            register: {
                username: { required, email },
                acceptterms: { sameAs: sameAs(true) }
            }
        }
    },
    computed: {
        user() {
            return userStore.user;
        },
        loggedIn() {
            return userStore.loggedIn;
        }
    },
    methods: {
        togglePassword() {
            if (this.passwordType === 'password') {
                this.passwordType = 'text';
            } else {
                this.passwordType = 'password';
            }
        },
        async submitForm() {
            const valid = await this.v$.login.$validate();
            if (!valid) return
            let data = {
                Email: this.login.username,
                Password: this.login.password,
                LongTerm: this.login.longTerm
            }
            const response = await this.fetchApiData(this.apiLogin, data, 'post');
            if (response && response.status === 200) {
                this.data = response.data;
                if (this.data.typeAlias === 'Success') {
                    userStore.updateUser(this.data.member);
                    location.href = this.returnUrl;
                } else if (this.data.typeAlias !== 'MemberNotFound' && this.data.typeAlias !== 'PasswordIncorrect' && this.data.typeAlias !== 'PasswordNotSet') {
                    this.loginFailed = true;
                } 
            } else {
                this.loginFailed = true;
            }
        },
        async makeNewAccount() {
            const valid = await this.v$.register.$validate();
            if (!valid) return
            let data = {
                Email: this.register.username,
                LanguageID: this.languageId,
                StartUrl: this.returnUrl !== '' ? this.returnUrl : '/',
                SignUpForNewsletter: this.register.registernewsletter
            }
            const response = await this.fetchApiData(this.apiRegister, data, 'post');
            if (response.status === 200) {
                this.accountSend = response.data;
            }
        },
        async checkUser() {
            const valid = await this.v$.login.username.$validate();
            if (!valid) return
            let url = this.apiCheckUser + '?email=' + this.login.username;
            const response = await this.fetchApiData(url, '', 'get');
            if (response.status === 200) {
                this.userExists = response.data;
                if (!this.userExists) {
                    this.register.username = this.login.username;
                }
                this.step = 2;
            }
        },
        async requestPassword() {
            const valid = await this.v$.login.username.$validate();
            if (!valid) return
            let query = {
                Email: this.login.username,
                StartUrl: this.returnUrl
            };
            const response = await this.fetchApiData(this.apiForgot, query, 'post');
            if (response.status === 200) {
                this.emailSend = true;
            }
        },
        toggleForgot() {
            this.userlogin = !this.userlogin;
            this.forgotPassword = !this.forgotPassword;
            this.emailSend = false;
        }
    },
    mounted() {
        if (this.$el.dataset.apilogin) this.apiLogin = this.$el.dataset.apilogin;
        if (this.$el.dataset.apicheckuser) this.apiCheckUser = this.$el.dataset.apicheckuser;
        if (this.$el.dataset.apiregister) this.apiRegister = this.$el.dataset.apiregister;
        if (this.$el.dataset.apiforgot) this.apiForgot = this.$el.dataset.apiforgot;
        if (this.$el.dataset.returnurl) this.returnUrl = this.$el.dataset.returnurl;
        if (this.$el.dataset.redirecturl) this.redirectUrl = this.$el.dataset.redirecturl;
        if (this.$el.dataset.languageid) this.languageId = this.$el.dataset.languageid;
        this.$nextTick(() => {
            if (this.loggedIn && this.redirectUrl) window.location.href = this.redirectUrl;
        });
    }
}

export default loginApp;
